import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import './Curriculum.css';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';

const baseUrl = process.env.REACT_APP_API_URL;
const port = process.env.REACT_APP_API_PORT;

// let idUsuario = 328;

const Curriculum = props => {
  const idUsuario = props.idUsuario;

  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [direccion, setDireccion] = useState('');
  const [localidad, setLocalidad] = useState('');
  const [provincia, setProvincia] = useState('');
  const [dni, setDni] = useState('');
  const [cuil, setCuil] = useState('');
  const [email, setEmail] = useState({ campo: '', valido: '' });
  const [telefono, setTelefono] = useState('');
  const [movil, setMovil] = useState('');
  const [sexo, setSexo] = useState(1);
  const [fecNacimiento, setFecNacimiento] = useState('');
  const [estadoCivil, setEstadoCivil] = useState(1);
  const [hijos, setHijos] = useState('0');
  const [institucion, setInstitucion] = useState('');
  const [tipoInstitucion, setTipoInstitucion] = useState(1);
  const [estadoInstitucion, setEstadoInstitucion] = useState(1);
  const [titulo, setTitulo] = useState('Abogacia');
  const [curso, setCurso] = useState('');
  const [fecDesdeCurso, setFecDesdeCurso] = useState('');
  const [fecHastaCurso, setFecHastaCurso] = useState('');
  const [expLaboral, setExpLaboral] = useState('');
  const [fecDesdeExpLaboral, setFecDesdeExpLaboral] = useState('');
  const [fecHastaExpLaboral, setFecHastaExpLaboral] = useState('');
  const [areasDeseadas, setAreasDeseadas] = useState('Tareas generales');
  const [ref, setRef] = useState('');
  const [fileCurriculum, setFileCurriculum] = useState('');
  const [datosPersonalesCompletos, setDatosPersonalesCompletos] =
    useState(false);
  const [estudiosCompletos, setEstudiosCompletos] = useState(false);
  const [expLaboralCompletos, setExpLaboralCompletos] = useState(false);
  const [acordionesCompletados, setAcordionesCompletados] = useState(false);
  const [datosColegios, setDatosColegios] = useState([]);
  const [idCurriculum, setIdCurriculum] = useState(null);
  const [datosTitulos, setDatosTitulos] = useState([]);
  const [datosCursos, setDatosCursos] = useState([]);
  const [datosExpLab, setDatosExpLab] = useState([]);
  const [datosAreaDeseada, setDatosAreaDeseada] = useState([]);
  const [datosListTitulosSelect, setDatosListTitulosSelect] = useState([]);
  const [tituloExist, setTituloExist] = useState(false);

  const [datosAreasSelect, setDatosAreasSelect] = useState([]);
  const [cantAreasDeseadas, setCantAreasDeseadas] = useState(false);

  const [tieneEstudios, setTieneEstudios] = useState(true);
  const [habilitiFile, setHabilitoFile] = useState(true);
  const [habilitoSaveBtn, setHabilitoSaveBtn] = useState(true);
  const [extFile, setExtFile] = useState('');
  const [rutaCv, setRutaCv] = useState(null);
  const [imgUpload, setImgUpload] = useState(
    'http://www.coop5.com.ar/pdfsCurriculum/imgUser/usersinfoto.png'
  );
  const [extImgUser, setExtImgUser] = useState('');

  const [imgEnd, setImgEnd] = useState(null);

  const getDatosUsuario = async () => {
    const url = `${baseUrl}${port}/curriculumVitae/${idUsuario}`;
    const resp = await fetch(url);
    const data = await resp.json();
    setNombre(data[0].Nombre);
    setApellido(data[0].Apellido);
    setDireccion(data[0].Direccion);
    setLocalidad(data[0].Localidad);
    setProvincia(data[0].Provincia);
    setDni(data[0].DNI);
    setCuil(data[0].CUIL);
    setEmail({ ...email, campo: data[0].Email });
    setTelefono(data[0].Telefono);
    setMovil(data[0].Celular);
    setSexo(data[0].IdSexo);
    setFecNacimiento(data[0].FecNac);
    setEstadoCivil(data[0].IdEstadoCivil);
    setHijos(data[0].Hijos);
    setIdCurriculum(data[0].IdCurriculum);
    setRutaCv(data[0].RutaCv);
    setFileCurriculum(data[0].RutaCv);

    if (
      data[0].TipoFoto.length > 0 &&
      data[0].TipoFoto != '' &&
      data[0].TipoFoto != null
    ) {
      let img = data[0].TipoFoto;

      setImgUpload(`http://www.coop5.com.ar/pdfsCurriculum/imgUser/${img}`);
    }

    if (fileCurriculum.length != 0) {
      enviarCurriculum(data[0].IdCurriculum);
    }
  };

  const getListaEstudios = async () => {
    const url = `${baseUrl}${port}/curriculumVitae/estudios/${idUsuario}`;
    const resp = await fetch(url);
    const data = await resp.json();
    setDatosColegios(data);
    if (data.length === 0) {
      setTieneEstudios(true);
    } else {
      setTieneEstudios(false);
    }
  };

  const getListaCursos = async () => {
    const url = `${baseUrl}${port}/curriculumVitae/router/router/cursos/${idUsuario}`;
    const resp = await fetch(url);
    const data = await resp.json();
    setDatosCursos(data);
  };

  //Agregamos estudios
  const addEstudios = async () => {
    if (institucion.length === 0) {
      Swal.fire({
        title: 'Debe ingresar el nombre de Institución - Colegio.',

        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#F5B041',
      });
    } else {
      var endpoint = `/curriculumVitae/router/router/router/router/router/addestudios/${idCurriculum}`;

      const url = `${baseUrl}${port}${endpoint}`;
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
          IdEduTipo: `${tipoInstitucion}`,
          IdEduEstado: `${estadoInstitucion}`,
          DsEdu: `${institucion}`,
        }),
      }).then(res => res.json());
      setInstitucion('');
    }

    getListaEstudios();
  };
  //Eliminamos estudios
  const deleteEstudios = async IdEdu => {
    var endpoint = `/curriculumVitae/router/router/router/router/router/deleteestudios`;
    const url = `${baseUrl}${port}${endpoint}`;
    await fetch(url, {
      method: 'DELETE',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        IdEdu: `${IdEdu}`,
        IdCurriculum: `${idCurriculum}`,
      }),
    }).then(res => res.json());
    getListaEstudios();
  };
  //Listamos los titulos en la lista desplegable...
  const getListTitulosSelect = async () => {
    const url = `${baseUrl}${port}/curriculumVitae/router/router/router/router/router/router/getTitulosList`;

    const resp = await fetch(url);
    const data = await resp.json();
    setDatosListTitulosSelect(data);
  };
  const getListaTitulos = async () => {
    const url = `${baseUrl}${port}/curriculumVitae/router/titulos/${idCurriculum}`;
    const resp = await fetch(url);
    const data = await resp.json();
    setDatosTitulos(data);
    if (data.length == 0) {
      setTituloExist(false);
    } else {
      setTituloExist(true);
    }
  };

  const deleteTitulo = async () => {
    var endpoint = `/curriculumVitae/router/router/router/router/router/router/deletetitulos/${idCurriculum}`;
    const url = `${baseUrl}${port}${endpoint}`;
    const resp = await fetch(url, {
      method: 'DELETE',
      headers: { 'Content-type': 'application/json' },
    });
    const data = await resp.json();

    getListaTitulos();
  };

  const addTitulo = async () => {
    if (tituloExist === true) {
      alert(
        'ya tiene un titulo registrado, debe eliminarlo si desea seleccionar otro'
      );
    } else {
      var endpoint = `/curriculumVitae/addtitulos`;
      const url = `${baseUrl}${port}${endpoint}`;
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
          titulo: `${titulo}`,
          IdCurriculum: `${idCurriculum}`,
        }),
      }).then(res => res.json());
      getListaTitulos();
    }
  };

  //Seccion Cursos...
  //Agregar Curso
  const addCursos = async () => {
    if (
      curso.length === 0 ||
      fecDesdeCurso.length === 0 ||
      fecHastaCurso.length === 0
    ) {
      Swal.fire({
        title: 'Debe ingresar todos los datos que se le solicita.',

        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#F5B041',
      });
    } else {
      var endpoint = `/curriculumVitae/addcursos/${idCurriculum}`;
      const url = `${baseUrl}${port}${endpoint}`;
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
          curso: `${curso}`,
          fecDes: `${fecDesdeCurso}`,
          fecHas: `${fecHastaCurso}`,
        }),
      }).then(res => res.json());

      setCurso('');
      setFecDesdeCurso('');
      setFecHastaCurso('');
    }
    getListaCursos();
  };
  const deleteCurso = async idcurso => {
    var endpoint = `/curriculumVitae/deletecurso`;
    const url = `${baseUrl}${port}${endpoint}`;
    await fetch(url, {
      method: 'DELETE',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        IdCurriculum: `${idCurriculum}`,
        IdCurso: `${idcurso}`,
      }),
    }).then(res => res.json());
    getListaCursos();
  };

  //Seccion Experiencias Laborales...

  const getExpLab = async () => {
    const url = `${baseUrl}${port}/curriculumVitae/router/router/router/explab/${idUsuario}`;
    const resp = await fetch(url);
    const data = await resp.json();
    setDatosExpLab(data);
  };

  const addExpLab = async () => {
    if (
      expLaboral.length === 0 ||
      fecDesdeExpLaboral.length === 0 ||
      fecHastaExpLaboral.length === 0
    ) {
      Swal.fire({
        title: 'Debe ingresar todos los datos que se le solicita.',

        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#F5B041',
      });
    } else {
      var endpoint = `/curriculumVitae/router/router/addexplab`;
      const url = `${baseUrl}${port}${endpoint}`;
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
          IdCurriculum: `${idCurriculum}`,
          experiencia: `${expLaboral}`,
          fecDes: `${fecDesdeExpLaboral}`,
          fecHas: `${fecHastaExpLaboral}`,
        }),
      }).then(res => res.json());
      setExpLaboral('');
      setFecDesdeExpLaboral('');
      setFecHastaExpLaboral('');
    }

    getExpLab();
  };

  const deleteExpLab = async idExp => {
    var endpoint = `/curriculumVitae/router/deleteExpLab`;
    const url = `${baseUrl}${port}${endpoint}`;
    await fetch(url, {
      method: 'DELETE',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        IdCurriculum: `${idCurriculum}`,
        IdExpLab: `${idExp}`,
      }),
    }).then(res => res.json());
    getExpLab();
  };

  //Seccion Areas deseadas...

  const getAreaDeseadaList = async () => {
    const url = `${baseUrl}${port}/curriculumVitae/router/router/router/router/router/router/router/getAreaDeseadaList`;
    const resp = await fetch(url);
    const data = await resp.json();
    setDatosAreasSelect(data);
  };

  const getAreaDeseada = async () => {
    const url = `${baseUrl}${port}/curriculumVitae/router/router/router/router/areadeseada/${idUsuario}`;
    const resp = await fetch(url);
    const data = await resp.json();

    if (data.length < 3) {
      setCantAreasDeseadas(true);
    } else {
      setCantAreasDeseadas(false);
    }

    setDatosAreaDeseada(data);
  };

  const addAreaDeseada = async () => {
    if (cantAreasDeseadas === true) {
      var endpoint = `/curriculumVitae/router/router/router/addAreaDeseada`;
      const url = `${baseUrl}${port}${endpoint}`;
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
          IdCurriculum: `${idCurriculum}`,
          areaDeseada: `${areasDeseadas}`,
        }),
      }).then(res => res.json());
      getAreaDeseada();
    } else {
      alert('ya tiene 3 cargadas');
    }
  };

  const deleteAreaDeseada = async DsAreaTrabajo => {
    var endpoint = `/curriculumVitae/router/router/deleteAreaDeseada`;
    const url = `${baseUrl}${port}${endpoint}`;
    await fetch(url, {
      method: 'DELETE',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        IdCurriculum: `${idCurriculum}`,
        areaDeseada: `${DsAreaTrabajo}`,
      }),
    }).then(res => res.json());
    getAreaDeseada();
  };

  //Seccion Referencias...
  // const getReferencias = async () => {
  //   const url = `${baseUrl}${port}/curriculumVitae/router/router/router/router/router/router/router/getRefObs/${idCurriculum}`;
  //   const resp = await fetch(url);
  //   const data = await resp.json();
  //   setRef(data[0].DsReferencia);
  // };

  const addRefObs = async () => {
    var endpoint = `/curriculumVitae/router/router/router/router/addRefObs`;
    const url = `${baseUrl}${port}${endpoint}`;
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        IdCurriculum: `${idCurriculum}`,
        ref: `${ref}`,
      }),
    }).then(res => res.json());
    setRef('');
  };

  const enviarCurriculum = async idCurriculum => {
    try {
      const formData = new FormData();

      formData.append('IdCurriculum', idCurriculum);
      formData.append('IdUsuario', idUsuario);
      formData.append('ext', extFile);
      formData.append('image', fileCurriculum);

      const endpoint = 'api/send-email/curriculum/upload';
      const url = `//api.coop5.com.ar:5002/${endpoint}`;
      const resp = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      const data = await resp.json();

      document.getElementById('formFile').value = null;

      // setFileCurriculum(null);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDatosUsuario();
    getListaEstudios();
    getListaCursos();
    getExpLab();
    getAreaDeseada();
    getListTitulosSelect();
    getAreaDeseadaList();
  }, [props.idUsuario]);

  useEffect(() => {
    getListaTitulos();
  }, [idCurriculum]);

  const updateOrAddCv = async () => {
    var endpoint =
      '/curriculumVitae/router/router/router/router/router/router/router/updateOrAddCurriculum';
    // endpoint = endpoint + `guardar/artefacto`;
    const url = `${baseUrl}${port}${endpoint}`;
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        nombre: `${nombre}`,
        apellido: `${apellido}`,
        direccion: `${direccion}`,
        localidad: `${localidad}`,
        provincia: `${provincia}`,
        dni: `${dni}`,
        cuil: `${cuil}`,
        email: `${email.campo}`,
        telefono: `${telefono}`,
        movil: `${movil}`,
        sexo: `${sexo}`,
        fecNacimiento: `${fecNacimiento}`,
        estadoCivil: `${estadoCivil}`,
        hijos: `${hijos}`,
        idUsuario: `${idUsuario}`,
        extFile: `${extFile}`,
      }),
    }).then(res => res.json());

    // .then(data => {
    //   mId = data[0];

    if (props.tieneCv === false) {
      Swal.fire({
        icon: 'success',
        title: 'Curriculum Creado Correctamente',
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      Swal.fire({
        icon: 'success',
        title: 'Datos actualizados correctamente',
        showConfirmButton: false,
        timer: 1500,
      });
    }
    props.setTieneCv(true);
    getDatosUsuario();
  };

  const onChange = (e, setStatus) => {
    setStatus(e.target.value);
  };

  const onChangeEmail = e => {
    setEmail({ ...email, campo: e.target.value });
  };

  const onChangeFile = (e, id) => {
    const file = e.target.files[0];
    const archivo = document.getElementById(id).value;
    const extension = archivo.substring(
      archivo.lastIndexOf('.'),
      archivo.length
    );
    if (e.target.files[0] != '') {
      if (
        document
          .getElementById(id)
          .getAttribute('accept')
          .split(',')
          .indexOf(extension) < 0
      ) {
        Swal.fire({
          title: `Archivo Inválido, no se permite la extensión ${extension}`,
          text: 'Solo se pueden cargar archivos con extensión .pdf y .docx',
          icon: 'warning',
          confirmButtonText: 'Ok',
          confirmButtonColor: '#ffb700',
          backdrop: 'rgb(255, 165, 0, 0.20)',
        });
        setFileCurriculum('');
      } else {
        setFileCurriculum(file);
        setExtFile(extension);
      }
    }
  };

  const validacionEmail = () => {
    const expReg =
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    if (expReg.test(email.campo)) {
      setEmail({ ...email, valido: 'true' });
    } else {
      setEmail({ ...email, valido: 'false' });
    }
  };

  //Compruebo que los datos personales esten completos...
  useEffect(() => {
    if (
      nombre != '' &&
      apellido != '' &&
      direccion != '' &&
      localidad != '' &&
      provincia != '' &&
      dni != '' &&
      cuil != '' &&
      email.valido != 'false' &&
      movil != '' &&
      sexo != '' &&
      fecNacimiento != '' &&
      estadoCivil != '' &&
      hijos >= 0 &&
      fileCurriculum != ''
    ) {
      setDatosPersonalesCompletos(false);
    } else {
      setDatosPersonalesCompletos(true);
    }
  }, [
    nombre,
    apellido,
    direccion,
    localidad,
    provincia,
    dni,
    cuil,
    email,
    telefono,
    movil,
    sexo,
    fecNacimiento,
    estadoCivil,
    hijos,
    fileCurriculum,
  ]);

  //Compruebo que los Estudios y datos personales esten completos...
  useEffect(() => {
    if (tieneEstudios === false && datosPersonalesCompletos === false) {
      setEstudiosCompletos(false);
    } else {
      setEstudiosCompletos(true);
    }
  }, [tieneEstudios, datosPersonalesCompletos]);

  //Compruebo para habilitar File CV...
  useEffect(() => {
    if (datosPersonalesCompletos != true && tieneEstudios != true) {
      setHabilitoFile(false);
    } else {
      setHabilitoFile(true);
    }
  }, [datosPersonalesCompletos, tieneEstudios]);

  useEffect(() => {
    if (
      datosPersonalesCompletos != true &&
      tieneEstudios != true
      // fileCurriculum.length != 0
    ) {
      setHabilitoSaveBtn(false);
    } else {
      setHabilitoSaveBtn(true);
    }
  }, [datosPersonalesCompletos, tieneEstudios]);

  const onChangeImgUpload = (e, id) => {
    const file = e.target.files[0];
    const imgPreview = URL.createObjectURL(file);
    const archivo = document.getElementById(id).value;
    const extension = archivo.substring(
      archivo.lastIndexOf('.'),
      archivo.length
    );
    if (e.target.files[0] != '') {
      if (
        document
          .getElementById(id)
          .getAttribute('accept')
          .split(',')
          .indexOf(extension) < 0
      ) {
        Swal.fire({
          title: `Archivo Inválido, no se permite la extensión ${extension}`,
          text: 'Solo se pueden cargar archivos con extensión .jpg, .png y .jpeg',
          icon: 'warning',
          confirmButtonText: 'Ok',
          confirmButtonColor: '#ffb700',
          backdrop: 'rgb(255, 165, 0, 0.20)',
        });
        // setImgUpload('');
      } else {
        setImgEnd(file);
        setImgUpload(imgPreview);
        setExtImgUser(extension);
      }
    }
  };

  const enviarImgUser = async () => {
    if (extImgUser != '') {
      try {
        const formData = new FormData();

        formData.append('IdCurriculum', idCurriculum);
        formData.append('IdUsuario', idUsuario);
        formData.append('ext', extImgUser);
        formData.append('image', imgEnd);

        const endpoint = 'api/send-email/curriculum/upload/imgUser';
        const url = `//api.coop5.com.ar:5002/${endpoint}`;
        const resp = await fetch(url, {
          method: 'POST',
          body: formData,
        });
        const data = await resp.json();
      } catch (error) {
        console.log(error);
      }
      uploadImgUserDB();
    }
  };
  const uploadImgUserDB = async () => {
    if (extImgUser != '') {
      var endpoint =
        '/curriculumVitae/router/router/router/router/router/router/router/router/uploadImgUser';
      // endpoint = endpoint + `guardar/artefacto`;
      const url = `${baseUrl}${port}${endpoint}`;
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
          idCurriculum: `${idCurriculum}`,
          idUsuario: `${idUsuario}`,
          extImgUser: `${extImgUser}`,
        }),
      }).then(res => res.json());
    }
    getDatosUsuario();
  };

  return (
    <>
      <div className="title-container-cv">
        <h1>CURRICULUM VITAE</h1>
      </div>
      <div className="imguser-container">
        <img src={imgUpload} alt="" />
        {props.tieneCv === true ? (
          <>
            <input
              id="imgUser"
              accept=".jpg,.png,.jpeg"
              onChange={e => onChangeImgUpload(e, 'imgUser')}
              type="file"
            />
          </>
        ) : (
          ''
        )}
      </div>
      <div className="container-curriculum">
        <Accordion className="acordion-container" defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <strong>
                <i>DATOS PERSONALES</i>
              </strong>
            </Accordion.Header>
            <Accordion.Body>
              <div class="accordion-body">
                {/* DATOS PERSONALES  */}

                <section>
                  <div class="container needs-validation fondo_form">
                    <form>
                      <div>
                        <div class="row g-3">
                          <div class="col">
                            <label for="nombre" class="cursor_label">
                              <i>NOMBRE/S</i>
                            </label>
                            <input
                              maxLength={30}
                              type="text"
                              class="form-control"
                              placeholder="Ingrese su nombre / s"
                              aria-label="First name"
                              id="nombre"
                              name="usuario"
                              value={nombre}
                              onChange={e => onChange(e, setNombre)}
                            />
                          </div>
                          <div class="col">
                            <label for="apellidos" class="cursor_label">
                              <i>APELLIDO/S</i>
                            </label>
                            <input
                              maxLength={30}
                              type="text"
                              class="form-control"
                              placeholder="Ingrese su apellido"
                              aria-label="Last name"
                              id="apellidos"
                              name="apellido"
                              value={apellido}
                              onChange={e => onChange(e, setApellido)}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row g-3">
                        <div class="row g-3">
                          <div class="col">
                            <label for="direccion" class="cursor_label">
                              <i>DIRECCION</i>
                            </label>
                            <input
                              maxLength={30}
                              type="text"
                              class="form-control"
                              placeholder="Ingrese su direccion"
                              aria-label="First name"
                              id="direccion"
                              name="direccion"
                              value={direccion}
                              onChange={e => onChange(e, setDireccion)}
                            />
                          </div>
                          <div class="col">
                            <label for="localidad" class="cursor_label">
                              <i>LOCALIDAD</i>
                            </label>
                            <input
                              maxLength={30}
                              type="text"
                              class="form-control"
                              placeholder="Ingrese su localidad"
                              aria-label="Last name"
                              id="localidad"
                              name="localidad"
                              value={localidad}
                              onChange={e => onChange(e, setLocalidad)}
                            />
                          </div>
                          <div class="col">
                            <label for="provincia" class="cursor_label">
                              <i>PROVINCIA</i>
                            </label>
                            <input
                              maxLength={20}
                              type="text"
                              class="form-control"
                              placeholder="Ingrese su provincia"
                              aria-label="Last name"
                              id="provincia"
                              name="provincia"
                              value={provincia}
                              onChange={e => onChange(e, setProvincia)}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row g-3">
                        <div class="row g-3">
                          <div class="col">
                            <label for="dni" class="cursor_label">
                              <i>D.N.I</i>
                            </label>
                            <input
                              maxLength={10}
                              type="number"
                              class="form-control"
                              placeholder="Ingrese su D.N.I."
                              aria-label="First name"
                              id="dni"
                              name="dni"
                              value={dni}
                              onChange={e => onChange(e, setDni)}
                            />
                          </div>
                          <div class="col">
                            <label for="cuil" class="cursor_label">
                              <i>CUIL</i>
                            </label>
                            <input
                              maxLength={13}
                              type="text"
                              class="form-control"
                              placeholder="Ingrese su N° de cuil"
                              aria-label="Last name"
                              id="cuil"
                              name="cuil"
                              value={cuil}
                              onChange={e => onChange(e, setCuil)}
                            />
                          </div>
                          <div class="col">
                            <label for="email" class="cursor_label">
                              <i>EMAIL</i>
                            </label>
                            <input
                              className={`form-control ${
                                email.valido === 'false' && 'input-email-false'
                              }`}
                              onBlur={validacionEmail}
                              onKeyUp={validacionEmail}
                              type="email"
                              class="form-control"
                              placeholder="Ingrese su email"
                              aria-label="Last name"
                              id="email"
                              name="email"
                              value={email.campo}
                              onChange={e => onChangeEmail(e)}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row g-3">
                        <div class="row g-3">
                          <div class="col">
                            <label for="telefono_fijo" class="cursor_label">
                              <i>TELEFONO</i>
                            </label>
                            <input
                              maxLength={12}
                              type="number"
                              class="form-control"
                              placeholder="Ingrese su N° de Telefono"
                              aria-label="First name"
                              id="telefono_fijo"
                              name="telefono"
                              value={telefono}
                              onChange={e => onChange(e, setTelefono)}
                            />
                          </div>
                          <div class="col">
                            <label for="telefono_movil" class="cursor_label">
                              <i>MOVIL</i>
                            </label>
                            <input
                              type="text"
                              maxLength={12}
                              class="form-control"
                              placeholder="Ingrese su N° de Movil"
                              aria-label="Last name"
                              id="telefono_movil"
                              name="movil"
                              value={movil}
                              onChange={e => onChange(e, setMovil)}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row g-3">
                        <div class="row g-3">
                          <div class="col">
                            <label>
                              <i>SEXO</i>
                            </label>
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              value={sexo}
                              onChange={e => onChange(e, setSexo)}
                            >
                              <option value="1" class="listado">
                                MASCULINO
                              </option>
                              <option value="2">FEMENINO</option>
                            </select>
                          </div>
                          <div class="col">
                            <label for="nacimiento">
                              <i>FECHA DE NACIMIENTO</i>
                            </label>
                            <input
                              type="date"
                              class="form-control"
                              aria-label="Last name"
                              id="nacimiento"
                              name="fecha_de_nacimiento"
                              value={fecNacimiento}
                              onChange={e => onChange(e, setFecNacimiento)}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row g-3">
                        <div class="row g-3">
                          <div class="col">
                            <label>
                              <i>ESTADO CIVIL</i>
                            </label>
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              value={estadoCivil}
                              onChange={e => onChange(e, setEstadoCivil)}
                            >
                              <option value="1">Soltero/a</option>
                              <option value="2">Casado/a</option>
                              <option value="2">Viudo/a</option>
                              <option value="2">Divorciado/a</option>
                              <option value="2">Concubinato</option>
                            </select>
                          </div>
                          <div class="col">
                            <label for="hijos" class="cursor_label">
                              <i>HIJOS</i>
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              placeholder="Ingrese cantidad"
                              aria-label="Last name"
                              id="hijos"
                              name="hijos"
                              value={hijos}
                              onChange={e => onChange(e, setHijos)}
                            />
                          </div>
                        </div>
                      </div>
                      {/* ---------------------- */}
                      <div class="row g-3">
                        <div class="row g-3">
                          <div class="col">
                            <label>
                              <i>CARGUE AQUI SU CURRICULUM VITAE (pdf,docx)</i>
                            </label>
                            <div>
                              <div>
                                <div class="mb-3">
                                  <input
                                    accept=".pdf,.docx"
                                    class="form-control"
                                    type="file"
                                    id="formFile"
                                    // value={fileCurriculum}
                                    onChange={e => onChangeFile(e, 'formFile')}
                                  />
                                </div>

                                {rutaCv != null ? (
                                  <>
                                    <a href=""></a>
                                    <a
                                      href={`http://www.coop5.com.ar/pdfsCurriculum/${rutaCv}
                            `}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <button
                                        type="button"
                                        class="btn btn-info"
                                      >
                                        Ver mi Curriculum
                                      </button>
                                    </a>
                                  </>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* --------------------------- */}

                      <br />
                    </form>
                  </div>
                </section>
              </div>
              {!props.tieneCv ? (
                <>
                  {' '}
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      disabled={datosPersonalesCompletos}
                      class="btn btn-primary me-md-2 btn-success"
                      type="button"
                      onClick={updateOrAddCv}
                    >
                      CREAR CURRICULUM
                    </button>
                  </div>
                </>
              ) : (
                ''
              )}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item className="estudios-acordion" eventKey="1">
            <Accordion.Header>
              <strong>
                <i>ESTUDIOS </i>
              </strong>
            </Accordion.Header>
            <Accordion.Body>
              <div class="accordion-body">
                {/* <!--ESTUDIOS--> */}

                <section class="estudios_personales">
                  <div class="container needs-validation fondo_form">
                    <div>
                      <div class="row g-3">
                        <div class="col">
                          <label for="educacion" class="cursor_label">
                            <i>
                              <strong>Institucion - Colegio</strong>
                            </i>
                          </label>
                          <input
                            disabled={datosPersonalesCompletos}
                            type="text"
                            class="form-control"
                            placeholder="Ingrese el nombre del colegio"
                            aria-label="First name"
                            id="educacion"
                            name="educacion"
                            value={institucion}
                            onChange={e => onChange(e, setInstitucion)}
                          />
                        </div>

                        <div class="col">
                          <label>
                            <i>Seleccione tipo</i>
                          </label>
                          <select
                            disabled={datosPersonalesCompletos}
                            class="form-select"
                            aria-label="Default select example"
                            value={tipoInstitucion}
                            onChange={e => onChange(e, setTipoInstitucion)}
                          >
                            <option value="1">Primaria</option>
                            <option value="2">Secundaria</option>
                            <option value="3">Terciaria</option>
                            <option value="4">Universitaria</option>
                          </select>
                        </div>
                        <div class="col">
                          <label>
                            <i>Seleccione estado</i>
                          </label>
                          <select
                            disabled={datosPersonalesCompletos}
                            class="form-select"
                            aria-label="Default select example"
                            value={estadoInstitucion}
                            onChange={e => onChange(e, setEstadoInstitucion)}
                          >
                            <option value="1">Completo</option>
                            <option value="2">En curso</option>
                            <option value="3">Incompleto</option>
                          </select>
                        </div>
                        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                          <button
                            onClick={addEstudios}
                            disabled={datosPersonalesCompletos}
                            class="btn btn-primary me-md-2 btn-success"
                            type="submit"
                          >
                            + AGREGAR ESTUDIO
                          </button>
                        </div>

                        <div class="table-responsive">
                          <table id="tablePreview" class="table table-hover">
                            <thead>
                              <tr>
                                <th width="">Institución</th>
                                <th width="">Tipo de educación</th>
                                <th width="">Estado</th>
                                <th>Eliminar</th>
                              </tr>
                            </thead>
                            {datosColegios.map((d, i) => {
                              i += 1;
                              const { DsEdu, DsEduEstado, DsEduTipo, IdEdu } =
                                d;

                              return (
                                <>
                                  <tbody>
                                    <tr>
                                      <th>{DsEdu}</th>
                                      <th>{DsEduTipo}</th>
                                      <th>{DsEduEstado}</th>

                                      <th>
                                        <button
                                          onClick={() => deleteEstudios(IdEdu)}
                                          className="delete-btn"
                                        >
                                          <FontAwesomeIcon icon={faTrashCan} />
                                        </button>
                                      </th>
                                    </tr>
                                  </tbody>
                                </>
                              );
                            })}
                          </table>
                        </div>

                        <div>
                          <label>
                            Si es titulado o elija "No Posee*{' '}
                            <strong>(OBLIGATORIO)</strong>
                          </label>
                          <select
                            disabled={tieneEstudios}
                            class="form-select"
                            aria-label="Default select example"
                            value={titulo}
                            onChange={e => onChange(e, setTitulo)}
                          >
                            {datosListTitulosSelect.map((d, i) => {
                              i += 1;
                              const { IdTitulo, DsTitulo } = d;

                              return (
                                <>
                                  <option>{DsTitulo}</option>
                                </>
                              );
                            })}
                          </select>
                        </div>

                        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                          <button
                            disabled={tieneEstudios}
                            class="btn btn-primary me-md-2 btn-success"
                            type="button"
                            onClick={addTitulo}
                          >
                            + AGREGAR TITULO
                          </button>
                        </div>

                        <div class="table-responsive">
                          <p>(*) Agregue solamente 1 (un) título o estado</p>
                          <table id="tablePreview" class="table table-hover">
                            <thead>
                              <tr>
                                <th width="">
                                  <strong>Titulo/Otro/No Posee</strong>
                                </th>
                                <th>
                                  <strong>Eliminar</strong>
                                </th>
                              </tr>
                            </thead>
                            {datosTitulos.map(d => {
                              const { DsTitulo } = d;
                              return (
                                <>
                                  <tbody>
                                    <tr>
                                      <th>{DsTitulo}</th>
                                      <th>
                                        <button
                                          onClick={deleteTitulo}
                                          className="delete-btn"
                                        >
                                          <FontAwesomeIcon icon={faTrashCan} />
                                        </button>
                                      </th>
                                    </tr>
                                  </tbody>
                                </>
                              );
                            })}
                          </table>
                        </div>
                        <br />

                        <div class="mb-3">
                          <label
                            for="curso_realizado"
                            class="form-label cursor_label"
                          >
                            Ingrese el nombre del curso:
                          </label>
                          <input
                            disabled={tieneEstudios}
                            type="text"
                            class="form-control"
                            id="curso_realizado"
                            placeholder="Ingrese el nombre del curso / de la capacitación"
                            name="cursos"
                            value={curso}
                            onChange={e => onChange(e, setCurso)}
                          />
                        </div>

                        <div class="row g-3">
                          <div class="col">
                            <label for="curso_desde">
                              <strong>Desde Fecha</strong>
                            </label>
                            <input
                              disabled={tieneEstudios}
                              type="date"
                              class="form-control"
                              aria-label="First name"
                              id="curso_desde"
                              name="inicio_curso"
                              value={fecDesdeCurso}
                              onChange={e => onChange(e, setFecDesdeCurso)}
                            />
                          </div>
                          <div class="col">
                            <label for="curso_hasta">
                              <strong>Hasta Fecha</strong>
                            </label>
                            <input
                              disabled={tieneEstudios}
                              type="date"
                              class="form-control"
                              aria-label="Last name"
                              id="curso_hasta"
                              name="final_curso"
                              value={fecHastaCurso}
                              onChange={e => onChange(e, setFecHastaCurso)}
                            />
                          </div>
                        </div>

                        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                          <button
                            onClick={addCursos}
                            disabled={tieneEstudios}
                            class="btn btn-primary me-md-2 btn-success"
                            type="submit"
                          >
                            + AGREGAR CURSO
                          </button>
                        </div>

                        <div></div>

                        <div class="table-responsive">
                          <table id="tablePreview" class="table table-hover">
                            <thead>
                              <tr>
                                <th width="">Nombre del curso</th>
                                <th width="">Fecha Inicio</th>
                                <th width="">Fecha Fin</th>
                                <th>Eliminar</th>
                              </tr>
                            </thead>
                            {datosCursos.map(d => {
                              const { DsCurso, FechaD, FechaH, idcurso } = d;

                              return (
                                <>
                                  <tbody>
                                    <tr>
                                      <th>{DsCurso}</th>
                                      <th>{FechaD}</th>
                                      <th>{FechaH}</th>
                                      <th>
                                        <button
                                          onClick={() => deleteCurso(idcurso)}
                                          className="delete-btn"
                                        >
                                          <FontAwesomeIcon icon={faTrashCan} />
                                        </button>
                                      </th>
                                    </tr>
                                  </tbody>
                                </>
                              );
                            })}
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <strong>
                <i>EXPERIENCIA LABORAL</i>
              </strong>
            </Accordion.Header>
            <Accordion.Body>
              <div class="accordion-body">
                {/* <!--EXPERIENCIA LABORAL--> */}

                <section class="experiencia_laboral fondo_form">
                  <div class="container">
                    <div>
                      <div class="row g-3 needs-validation">
                        <div class="col">
                          <label for="experiencia_lab" class="cursor_label">
                            <strong>Experiencia Laboral</strong>
                          </label>
                          <input
                            disabled={estudiosCompletos}
                            type="text"
                            class="form-control"
                            placeholder="Ingrese sus experiencias"
                            aria-label="First name"
                            id="experiencia_lab"
                            name="exp_laboral"
                            value={expLaboral}
                            onChange={e => onChange(e, setExpLaboral)}
                          />
                        </div>
                        <div class="col">
                          <label for="desde_exp">
                            <strong>Desde Fecha:</strong>
                          </label>
                          <input
                            disabled={estudiosCompletos}
                            type="date"
                            class="form-control"
                            aria-label="Last name"
                            id="inicio_laboral"
                            value={fecDesdeExpLaboral}
                            onChange={e => onChange(e, setFecDesdeExpLaboral)}
                          />
                        </div>
                        <div class="col">
                          <label for="hasta_exp">
                            <strong>Hasta Fecha:</strong>
                          </label>
                          <input
                            disabled={estudiosCompletos}
                            type="date"
                            class="form-control"
                            aria-label="Last name"
                            id="final_laboral"
                            value={fecHastaExpLaboral}
                            onChange={e => onChange(e, setFecHastaExpLaboral)}
                          />
                        </div>
                      </div>
                      <br />

                      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          disabled={estudiosCompletos}
                          class="btn btn-primary me-md-2 btn-success"
                          type="submit"
                          onClick={addExpLab}
                        >
                          + AGREGAR EXP.
                        </button>
                      </div>

                      <div class="table-responsive">
                        <p>
                          <strong>
                            <i>
                              Si desea eliminar sus experiencias, haga click en
                              el botón de opción.
                            </i>
                          </strong>
                        </p>
                        <table id="tablePreview" class="table table-hover">
                          <thead>
                            <tr>
                              <th width="">
                                <strong>Experiencia Laboral</strong>
                              </th>
                              <th width="">
                                <strong>Desde Fecha</strong>
                              </th>
                              <th width="">
                                <strong>Hasta Fecha</strong>
                              </th>
                              <th>Eliminar</th>
                            </tr>
                          </thead>
                          {datosExpLab.map(d => {
                            const { DsExpLab, FechaD, FechaH, IdExpLab } = d;

                            return (
                              <>
                                <tbody>
                                  <tr>
                                    <th>{DsExpLab}</th>
                                    <th>{FechaD}</th>
                                    <th>{FechaH}</th>
                                    <th>
                                      <button
                                        onClick={() => deleteExpLab(IdExpLab)}
                                        className="delete-btn"
                                      >
                                        <FontAwesomeIcon icon={faTrashCan} />
                                      </button>
                                    </th>
                                  </tr>
                                </tbody>
                              </>
                            );
                          })}
                        </table>
                      </div>
                      <br />

                      <div>
                        <p>
                          <strong>
                            Área de trabajo deseada - Ingrese hasta tres (3)
                          </strong>
                        </p>
                        <select
                          disabled={estudiosCompletos}
                          class="form-select"
                          aria-label="Default select example"
                          value={areasDeseadas}
                          onChange={e => onChange(e, setAreasDeseadas)}
                        >
                          {datosAreasSelect.map(d => {
                            const { IdAreaTrabajo, DsAreaTrabajo } = d;

                            return (
                              <>
                                <option selected>{DsAreaTrabajo}</option>
                              </>
                            );
                          })}
                        </select>
                      </div>
                      <br />
                      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          disabled={estudiosCompletos}
                          class="btn btn-primary me-md-2 btn-success"
                          type="button"
                          onClick={addAreaDeseada}
                        >
                          + AGREGAR AREA
                        </button>
                      </div>
                      <br />

                      <div class="table-responsive">
                        <table id="tablePreview" class="table table-hover">
                          <thead>
                            <tr>
                              <th width="">
                                <strong>Área de trabajo seleccionada</strong>
                              </th>
                              <th>Eliminar</th>
                            </tr>
                          </thead>
                          {datosAreaDeseada.map(d => {
                            const { DsAreaTrabajo } = d;
                            return (
                              <>
                                <tbody>
                                  <tr>
                                    <th>{DsAreaTrabajo}</th>
                                    <th>
                                      <button
                                        onClick={() => {
                                          deleteAreaDeseada(DsAreaTrabajo);
                                        }}
                                        className="delete-btn"
                                      >
                                        <FontAwesomeIcon icon={faTrashCan} />
                                      </button>
                                    </th>
                                  </tr>
                                </tbody>
                              </>
                            );
                          })}
                        </table>
                      </div>
                      <br />

                      <div class="mb-3">
                        <label for="ref_y_obs" class="form-label cursor_label">
                          <strong>Referencias y observaciones</strong>
                        </label>
                        <textarea
                          disabled={estudiosCompletos}
                          class="form-control"
                          id="ref_y_obs"
                          rows="3"
                          placeholder="Ingrese sus referencias y observaciones "
                          value={ref}
                          onChange={e => onChange(e, setRef)}
                        ></textarea>
                      </div>

                      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          disabled={estudiosCompletos}
                          class="btn btn-primary me-md-2 btn-success"
                          type="button"
                          onClick={addRefObs}
                        >
                          + AGREGAR REF. Y OBS.
                        </button>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div
          id="btns-container"
          class="d-grid gap-2 d-md-flex justify-content-md-end"
        >
          <button
            id="btn-save-datos"
            disabled={habilitoSaveBtn}
            class="btn btn-primary me-md-2 btn-success"
            type="submit"
            onClick={
              () => {
                updateOrAddCv();
                enviarImgUser();
              }
              // enviarCurriculum();
            }
          >
            GUARDAR DATOS
          </button>
        </div>
      </div>
    </>
  );
};

export { Curriculum };
